module.exports = __webpack_public_path__ + "media/images/design/images/dantai/star4-50cdbc139888c21e809f2ae37b903954-cfe029baafc1320fa5db2608e134bb23.gif";